import { render, staticRenderFns } from "./CategoriaTabela.vue?vue&type=template&id=c1cc8da2&lang=html"
import script from "./CategoriaTabela.vue?vue&type=script&lang=js"
export * from "./CategoriaTabela.vue?vue&type=script&lang=js"
import style0 from "./CategoriaTabela.vue?vue&type=style&index=0&id=c1cc8da2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports